import React from "react";
import { Trans } from "@lingui/macro";
import { useWeb3React } from "@web3-react/core";
import { BigNumber } from "ethers";

import { useAccountVestInfoBySheduleIndex } from "../../domain/stats/useVestInfo";
import { formatAmount } from "../../lib/numbers";
import { PALM_DECIMALS } from "../Event/hooks/constants";

const TierInfoTooltip = ({ scheduleIndex }: { scheduleIndex: BigNumber }) => {
  const { account } = useWeb3React();
  const { accountVestInfo } = useAccountVestInfoBySheduleIndex(account, scheduleIndex.toNumber());

  return (
    <div className="absolute z-10 rounded-sm bottom-[0.6rem] w-[34rem] left-[4rem] bg-background-4-hover p-[2rem] border border-border">
      <div className="text-[1.2rem] text-white mb-[1.4rem]">
        <Trans>More Information (ID #00{scheduleIndex.toString()})</Trans>
      </div>
      <div className="relative @container/table tailwind isolate mt-[0.6rem]">
        <div className="max-h-none scroll-smooth custom-scrollbar overflow-y-auto">
          {accountVestInfo && (
            <table className="w-full">
              <thead className="sticky top-0">
                <tr>
                  <th className="first:rounded-l-sm bg-background-3 h-14 text-[1.2rem] leading-[1.5] text-inactive font-normal text-left px-6">
                    <Trans>Tier</Trans>
                  </th>
                  <th className="bg-background-3 h-14 text-[1.2rem] leading-[1.5] text-inactive font-normal text-left px-6">
                    <Trans>Total Commitment</Trans>
                  </th>
                  <th className="last:rounded-r-sm bg-background-3 h-14 text-[1.2rem] leading-[1.5] text-inactive font-normal text-left px-6">
                    <Trans>Total PLP</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-[1.4rem] leading-[1.5] px-6 py-[1.2rem]">{accountVestInfo.tier + 1}</td>
                  <td className="text-[1.4rem] leading-[1.5] px-6 py-[1.2rem]">
                    {formatAmount(accountVestInfo.totalAllocated, PALM_DECIMALS, 2, true)}
                  </td>
                  <td className="text-[1.4rem] leading-[1.5] px-6 py-[1.2rem]">
                    {formatAmount(accountVestInfo.totalPlp, PALM_DECIMALS, 2, true)}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default TierInfoTooltip;
